<template>
  <div class="firmware px">
    <img class="logo" :src="images.logo_white" />
    <div class="version" @click="updateFirmware">
      <span>
        {{ $t("loader.firmwareVersion") }}
        <img
          class="new"
          :src="images.icon_new"
          v-show="!currentDevice.isLatestVersion"
        />
      </span>
      <span class="code">
        {{ currentDevice.version }} <i class="iconfont iconarrow-right" />
      </span>
    </div>
    <div
      class="description"
      v-html="
        !currentDevice.isLatestVersion
          ? $t('loader.updateDescription') +
            (isCN
              ? currentDevice.updateDescription.zh_CN ||''
              : currentDevice.updateDescription.en_US ||'')
          : ''
      "
    ></div>
    <div class="button" @click="onSelectJson">
      {{ $t("loader.selectJSON") }}
    </div>
    <div class="tip" v-if="currentDevice.isLatestVersion">
      {{ $t("loader.isLatestVersion") }}
    </div>
    <c-progress
      v-if="percent >= 0 && percent <= 100"
      :percent="percent"
      :text="progressText"
      :image="images['device_' + currentDevice.code]"
      @close="percent = -1"
    />
    <div class="transport" @click="onTransport"></div>
    <div class="laboratory" @click="$router.replace($paths.laboratory)"></div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      percent: -1,
      progressText: "",
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("app", {
      isCN: "isCN",
    }),
    ...mapState("loader", {
      inLoader: "inLoader",
      systemInfo: "systemInfo",
      currentDevice: "currentDevice",
    }),
  },
  methods: {
    onSelectJson() {
      this.$store.dispatch("loader/loadJson");
    },
    updateFirmware() {
      if (this.currentDevice.isLatestVersion) return;
      console.log("================", new Date().getTime(), "================");
      this.$store.dispatch("loader/updateFirmware");
    },
    onTransport() {
      this.$confirm({
        title: this.$t("loader.transport"),
        okText: this.$t("yes"),
        cancelText: this.$t("cancel"),
        centered: true,
        onOk: () => {
          this.$store.dispatch("loader/transportMode");
        },
      });
    },
  },
  mounted() {
    window.loadingJsonProgress = (json) => {
      if (json) {
        const data = JSON.parse(json);
        this.percent = data.progress;
        this.progressText = this.isCN ? data.message.zh_CN : data.message.en_US;
        if (this.percent >= 100) {
          this.$store.dispatch("loader/getSystemInfo");
        } else if (this.percent === -1) {
          this.$info({
            title: this.$t("loader.failToLoad"),
            width: "8.4rem",
            okText: this.$t("yes"),
            cancelText: this.$t("cancel"),
            centered: true,
          });
        }
      }
    };
    window.updatingFirmwareProgress = (json) => {
      console.log("----------------", new Date().getTime(), "----------------");
      if (json) {
        const data = JSON.parse(json);
        this.percent = data.progress;
        this.progressText = this.isCN ? data.message.zh_CN : data.message.en_US;
        if (this.percent >= 100) {
          this.$store.dispatch("loader/getSystemInfo");
        } else if (this.percent === -1) {
          this.$info({
            title: this.$t("loader.failToUpdate"),
            width: "8.4rem",
            okText: this.$t("yes"),
            cancelText: this.$t("cancel"),
            centered: true,
          });
        }
      }
    };
  },
};
</script>
<style lang="scss" scoped>
.firmware {
  font-size: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 150px;

  .logo {
    width: 300px;
    height: auto;
    margin-bottom: 60px;
  }

  .version {
    @include flex-center;
    justify-content: space-between;
    width: 720px;
    padding: 10px 0;
    border-bottom: 3px solid #1d1d1d;
    font-size: 36px;
    margin-bottom: 30px;

    span {
      letter-spacing: 0;
    }

    .code {
      font-size: 28px;
      color: #3c3c3c;
      cursor: pointer;

      .iconfont {
        font-size: 28px;
      }
    }

    .new {
      width: 56px;
      vertical-align: text-top;
      margin-top: -10px;
    }
  }

  .description {
    width: 720px;
    height: 250px;
    word-break: break-all;
    white-space: pre-wrap;
    font-size: 28px;
    overflow-y: auto;
    margin-bottom: 30px;
  }

  .button {
    @include linear-button;
    width: 480px;
    height: 80px;
    line-height: 80px;
    margin-bottom: 60px;
  }

  .tip {
    height: 28px;
    line-height: 28px;
    font-size: 24px;
    text-align: center;
  }

  .transport,
  .laboratory {
    width: 80px;
    height: 80px;
    background: url("../assets/images/icon_firmware.svg") center / 40px 40px
      no-repeat;
    position: fixed;
    right: 30px;
    bottom: 30px;
    cursor: pointer;

    &.active,
    &:hover {
      background-image: url("../assets/images/icon_firmware_active.svg");
    }
  }

  .transport {
    right: 110px;
    background: url("../assets/images/icon_transport.svg") center / 40px 40px
      no-repeat;

    &.active,
    &:hover {
      background-image: url("../assets/images/icon_transport_active.svg");
    }
  }
}
</style>
